<template>
  <Reference
    :id="invoiceId"
    :value="value"
    :label="label || 'Рахунок'"
    :items.sync="items"
    :total-items="totalItems"
    :color-fn="colorInvoice"
    component-name="Invoice"
    placeholder="Введіть найменування клієнта або номер рахунку"
    @input="$emit('input', $event)"
    @getItems="getItems"
  />
</template>

<script>
import Reference from "@/components/Reference";
import * as invoicesApi from "@/backend/invoicesApi.js";
import { getInvoices } from "@/backend/clientsApi.js";

export default {
  components: {
    Reference,
  },
  props: {
    label: {
      type: String,
      default: "Рахунок",
    },
    value: {
      type: Object,
    },
    placeholder: {
      type: String,
      default: "",
    },
    clientId: {
      type: Number,
    },
    icon: {
      type: String,
    },
    productId: {
      type: Number,
    },
  },
  data: () => ({
    items: [],
    totalItems: 0,
  }),
  computed: {
    invoiceId() {
      return this.value?.id || null;
    },
  },
  methods: {
    async getItems({ currentPage, perPage, search }) {
      if (this.clientId && this.productId) {
        const { result, totalItems } = await getInvoices(
          this.clientId,
          this.productId,
          currentPage,
          perPage,
          search
        );
        this.items = [...this.items, ...result];
        this.totalItems = totalItems;
      } else {
        const { result, totalItems } = await invoicesApi.selectInvoice(
          currentPage,
          perPage,
          search
        );
        this.items = [...this.items, ...result];
        this.totalItems = totalItems;
      }
    },
    colorInvoice(invoice){
      return invoice.boundToClientProduct ? "color: orange" : "";
    },
  },
};
</script>
